<template>
    <div class="enterSecretQuestion-screen">

        <div class="leftContent">
            <custom-header :img-number="7"></custom-header>
        </div>
        <div class="rightContent" >
            <div class="headBlock">
                <custom-header />
            </div>
            <div class="wrap enterSecretQuestion_content">
                <div class="grow"></div>
                <h2  v-text="$ml.get('setSecretQuestionTitle2Reg')">Секретне запитання:</h2>
                <p v-if="!isMobile" v-html="$ml.get('setSecretQuestionTextReg')"></p>
                <login-input-select
                        :defaultCurrentIndex="defaultQuestionIndex"
                    :select-array="selectSecretQuestionArr"
                    :placeholder="$ml.get('setSecretQuestionPlaceholderQuestionReg')"
                    @setItem="currentQuestion = $event"
                ></login-input-select>
                <login-input
                        id="answer"
                        name="answer"
                        class="textFieldSetAnswer"
                        :placeholder="$ml.get('setSecretQuestionPlaceholderAnswerReg')"
                        v-model="inputValue"
                        :is-not-valid="isNotValid"
                        :valid-message="isNotValidMessage"
                        :maxlength="30"
                        @keydown.native.enter="nextScreen"
                >
                    <template slot="trailingIconSlot">
                        <login-select-code
                                class="trailingSelect"
                                :select-array="selectArray"
                                :defaultCurrentItem="currentAnswerLang"
                                @setItem="changeLang"
                        ></login-select-code>
                    </template>
                </login-input>

                <div class="grow"></div>
                <div class="bottom">
                    <div class="left">
                        <custom-button
                                :button-text="$ml.get('back')"
                                back
                                :action="back"
                        ></custom-button>
                    </div>
                    <div class="right">
                        <custom-button
                                :button-text="$ml.get('next')"
                                success
                                :disabled="disabledButton"
                                :action="nextScreen"
                        ></custom-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomHeader from "../../components/ui/custom-header";
    import LoginInput from "../../components/ui/login-input";
    import CustomButton from "../../components/ui/custom-button";
    import LoginInputSelect from "../../components/ui/login-input-select";
    import Profile from "../../helpers/profile";
    import LoginSelectCode from "../../components/ui/login-select-code";

    export default {
        name: "setSecretQuestionPage",
        components: {LoginSelectCode, LoginInputSelect, CustomButton, LoginInput, CustomHeader},
        data() {
            return {
                inputValue: Profile.registerAnswer || '',

                langIcon: '<svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '                        <rect y="0.5" width="28" height="21" rx="4" fill="#FFDD2D"/>\n' +
                    '                        <path d="M0 4.5C0 2.29086 1.79086 0.5 4 0.5H24C26.2091 0.5 28 2.29086 28 4.5V11H0V4.5Z" fill="#019BF2"/>\n' +
                    '                        </svg>',
                isNotValid: false,
                isNotValidMessage: this.$ml.get('secretQuestionErrorAnswer'),

                isMobile: true,
                currentQuestion: Profile.registerQuestion ? {id: Profile.registerQuestion, title: Profile.squestionList[Profile.registerQuestion]} : null,
                selectArray: [
                    {
                        logo: '<img src="../static/flags/uk.png" alt="Українська">',
                        name: 'Українська',
                        lang: 'uk'
                    },{
                        logo: '<img src="../static/flags/ru.png" alt="Русский">',
                        name: 'Русский',
                        lang: 'ru'
                    },{
                        logo: '<img src="../static/flags/en.png" alt="English">',
                        name: 'English',
                        lang: 'en'
                    },
                ],

            }
        },

        computed: {
            selectSecretQuestionArr: function () {
                let arr = [];
//                Profile.squestionList = {CityWereYouBorn: "Місце народження", MothersMaidenName:
//                    "Дівоче прізвище матері"}; //TODO удалить - тестовые данные
                for (let key in Profile.squestionList)
                    arr.push({id: key, title: Profile.squestionList[key]});
                return arr;
            },
            disabledButton: function () {
                return !this.inputValue.length || !this.currentQuestion
            },

            currentAnswerLang: function () {
                return this.selectArray.findIndex((item)=>{return item.lang == Profile.language});
            },

            defaultQuestionIndex: function() {
                return this.selectSecretQuestionArr.findIndex(item => item.id === Profile.registerQuestion);
            },

        },

        created() {
            this.isMobile = window.innerWidth < 600;
        },
        methods: {
            nextScreen: function () {
                if (!this.currentQuestion || !this.inputValue)
                    return;
                Profile.setData({
                    registerQuestion: this.currentQuestion.id,
                    registerAnswer: this.inputValue
                });
                if (Profile.process === 'login')
                    this.$router.push('/login/setPromptSecretQuestion');
                else if (Profile.process === 'accessRecovery')
                    this.$router.push('/accessRecovery/setPromptSecretQuestion');
                else
                    this.$router.push({ name: 'RegistrationSetPromptSecretQuestion'});
            },

            back: function () {
                this.$router.back();
            },

            changeLang: function (data) {
                Profile.registerAnswerLang = data.lang;
            },
        }
    }
</script>
<style lang="scss">
    .rightContent .textFieldSetAnswer input.loginInput_text {
        padding-right: 70px;
        &:focus {padding-right: 70px;}
    }
</style>
<style lang="scss" scoped>
    .enterSecretQuestion_content {
        display: flex;
        flex-direction: column;
        min-height: calc(100vh - 150px);
        justify-content: space-between;
        padding: 10% 6% 0;
        .loginInput {
            margin-bottom: auto;
        }
        p {text-align: left;}
        .trailingSelect { margin-right: -10px;}
    }

    @media (min-width: 601px) and (max-width: 750px) {
        .enterSecretQuestion_content {
            height: calc(100vh - 220px);
            max-height: 700px;
        }
    }
    @media (min-width: 751px) {

        .enterSecretQuestion_content  {
            height: calc(100vh - 220px);
            max-height: 700px;
        }
    }
</style>